import React, { useState } from "react";
import AppShell from "../../components/AppShell";
import { RulesForm } from "../../components/autoreg/RulesForm";
import { AdjustmentsTab } from "../../components/autoreg/AdjustmentsTab";
import { LocksTab } from "../../components/autoreg/LocksTab";
import { CoachOverview } from "../../components/autoreg/CoachOverview";
import { HistoryTab } from "../../components/autoreg/HistoryTab";

const TABS = [["overview", "Panel"], ["rules", "Reglas"], ["adjustments", "Ajustes aplicados"], ["history", "Historial"], ["locks", "Bloqueos"]];

export default function AdminAutoreg() {
  const [tab, setTab] = useState("overview");
  return (
    <AppShell>
      <div className="qv-page-head" data-testid="admin-autoreg">
        <div className="label">Cuestionario diario → sesiones</div>
        <h1>Reglas de autorregulación</h1>
        <p className="sub">Define cómo se adaptan automáticamente las sesiones según el bienestar de cada futbolista.</p>
      </div>
      <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap" }}>
        {TABS.map(([k, l]) => <button key={k} className={tab === k ? "qv-btn-primary" : "qv-btn-ghost"} style={{ padding: "8px 14px" }} onClick={() => setTab(k)} data-testid={`ar-tab-${k}`}>{l}</button>)}
      </div>
      {tab === "overview" && <CoachOverview go={setTab} />}
      {tab === "history" && <HistoryTab />}
      {tab === "rules" && <RulesForm />}
      {tab === "adjustments" && <AdjustmentsTab />}
      {tab === "locks" && <LocksTab />}
    </AppShell>
  );
}
